import React, { CSSProperties, useEffect, useRef, useState } from 'react';

export interface FadeInImageProps {
  src?: string;
  srcSet?: string;
  alt?: string;
  width?: number;
  height?: number;
  imgId?: string;
  ariaLabel?: string;
  ariaHidden?: boolean;
  style?: CSSProperties;
}

export const FadeInImage: React.FC<FadeInImageProps> = ({
  src,
  srcSet,
  alt,
  width,
  height,
  imgId,
  ariaLabel,
  ariaHidden,
  style
}) => {
  const imgRef = useRef<HTMLImageElement>(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const loadedStyles: CSSProperties = isLoaded ? { opacity: 1 } : {};
  const handleLoad = () => setIsLoaded(true);
  useEffect(() => {
    const img = imgRef.current;
    return () => {
      if (img) {
        // コンポーネントがunmountedになるタイミングでpendingリクエストをキャンセルする
        // https://stackoverflow.com/questions/5278304/how-to-cancel-an-image-from-loading
        img.src = '';
        img.onload = null;
      }
    };
  }, [imgRef]);

  return (
    <img
      ref={imgRef}
      id={imgId}
      src={src}
      srcSet={srcSet}
      alt={alt || ''}
      style={{ transition: 'opacity 0.2s ease 0s', opacity: 0, ...style, ...loadedStyles }}
      onLoad={handleLoad}
      aria-label={ariaLabel}
      width={width}
      height={height}
      aria-hidden={ariaHidden}
    />
  );
};
